/**=========================================================
 * Module: chat.js
 * Chat Controller
 =========================================================*/

 App.controller('ChatController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
  'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
   "use strict";

    $scope.page = {
      title: 'labels.CHATSTATS'
    };

    var startingDate = new Date(2018, 0, 1);

    $scope.model = {
      type:'chat'
    }
    $scope.showResults = false;
    $scope.suppliersById = {};
    
    

          $scope.form = {
            title: '',
            status: '',
            type: 'stat',
            model: $scope.model,
            fields: [
              {
                available: true,
                type: 'select',
                name: 'admin',
                placeholder: 'labels.ALL',
                valueField: 'id',
                labelField: 'name',
                data: $rootScope.admins,
                label: 'fields.LANGUAGEANALYST'
            },
            {
                available: true,
                type: 'select',
                name: 'client',
                placeholder: 'labels.ALL',
                valueField: 'id',
                labelField: 'name',
                data: $rootScope.clients,
                label: 'fields.CLIENT'
            },{
              available: true,
              type: 'select',
              name: 'supplier',
              placeholder: 'labels.ALL',
              valueField: 'id',
              labelField: 'name',
              data: $rootScope.suppliers,
              label: 'fields.SUPPLIER'
            },
              {
                available: true,
                type: 'date',
                name: 'from',
                minDate: startingDate
              },{
                available: true,
                type: 'date',
                name: 'to',
                minDate: startingDate
              },{
                available: true,
                type: 'submit'
              }
            ],
            submit: function(){
              if(!$scope.model.from) $scope.model.from = startingDate.getTime();
              $scope.form.status = 'submitting'
              $scope.showResults = false;
              D.save('stat', $scope.model).then(function(response){
                var statId = response.id;
                waitForStat(statId);
              }).catch(console.error);
            }
          }
      

    $scope.showRows = {};
    var waitForStat = function(id){
      D.load('stat', id).then(function(response){
        if(response && response.result){
          $scope.form.status = '';
          $scope.stat = response.result;
          $scope.statArray = [];
          $scope.projectsData = response.result.projectsData;
          for(var i=0; i<$scope.projectsData.length; i++){
            $scope.projectsData[i].qa = $scope.stat[$scope.projectsData[i].id].qa;
            $scope.projectsData[i].m = $scope.stat[$scope.projectsData[i].id].m;
            $scope.statArray.push($scope.projectsData[i]);
          }
          $scope.showResults = true;
        } else {
          $timeout(function(){waitForStat(id);}, 10000);
        }
      }).catch(function(err){
        $timeout(function(){waitForStat(id);}, 10000);
      });
    }

    $scope.openProjectsData = function(){
    	var scope = $scope.$new();
	    scope.data = $scope.projectsData;
        scope.table = {
            title: '',
            filter: false,
            fields: [
                {
                    available: true,
                    hasLink: true,
                    name: 'code',
                    label: 'PROJECTCODE'
                },{
                    available: true,
                    name: 'name'
                },{
                    available: false && $rootScope.user.groupType!='CLIENT',
                    name: 'client'
                },{
                    available: true,
                    name: 'createdOn',
                    label: 'DATE',
                    type: 'date',
                    def: '-'
                },{
                    available: true,
                    name: 'source',
                    type: 'enum',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'destinations',
                    type: 'enumSet',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'supplier',
                    label: 'CHOSENSUPPLIER'
                },{
                    available: false,
                    name: 'referent'
                },{
                    available: false,
                    name: 'totalWords'
                },{
                    available: false,
                    name: 'normalizedWords'
                },{
                    available: false,
                    name: 'recoveredWords'
                }
            ],
            link: {
                state: 'app.do',
                action: 'open',
                type: 'project',
                filter: 'id'
            }
        };
	    ngDialog.open({
	      template: '/app/views/entities/stats-projectsdata.html',
	      className: 'ngdialog-theme-large',
	      scope: scope,
	      cache: false
        });

    };

 }]);
